<div class="w-3/4 m-auto" *transloco="let t; prefix: 'userProfile'">
  <div class="font-semibold text-xl mb-4">{{ t('header') }}</div>
  <div class="card">
    <div class="flex flex-col h-full">
      <div class="flex items-center">
        <div class="relative flex items-center">
          <div class="font-semibold text-xl">{{ t('changePassword.header') }}</div>
        </div>
        <div class="flex items-center ml-auto">
          <p-button
            data-testid="open-dialog-button"
            (onClick)="openDialog()"
            label="{{ t('changePassword.button') }}"
            severity="secondary"
          />
        </div>
      </div>
    </div>
  </div>

  <form [formGroup]="form" (ngSubmit)="onSubmit()" class="card mt-5">
    <div class="flex flex-col h-full">
      <div class="flex items-center">
        <div class="relative flex items-center">
          <div class="font-semibold text-xl">{{ t('profileInformation.header') }}</div>
        </div>
        <div class="flex items-center ml-auto">
          @if (editing) {
            <p-button
              data-testid="save-button"
              type="submit"
              label="{{ 'common.save' | transloco }}"
              [loading]="submitting"
            ></p-button>
          } @else {
            <p-button
              data-testid="edit-button"
              label="{{ 'common.edit' | transloco }}"
              (onClick)="onEdit()"
              severity="secondary"
            />
          }
        </div>
      </div>
      @if (scimManaged) {
        <p-message
          severity="info"
          variant="simple"
          size="small"
          class="mt-4"
          data-testid="scim-managed-hint"
        >
          {{ 'user.scimManaged.hint' | transloco }}
        </p-message>
      }
      <p-fluid>
        <div class="flex flex-col gap-4 mt-4 mb-4">
          <app-form-field id="firstName" fieldName="firstName" label="common.firstName">
          </app-form-field>

          <app-form-field
            id="lastName"
            fieldName="lastName"
            label="common.lastName"
          ></app-form-field>

          @if (showCustomerAdminFields) {
            <div class="flex flex-col gap-4">
              <app-form-field
                id="companyName"
                fieldName="companyName"
                label="common.companyName"
              ></app-form-field>
              <app-form-field
                id="email"
                fieldName="email"
                label="common.email"
                type="email"
                placeholder="beispiel@email.com"
              ></app-form-field>
            </div>
          }
          <app-form-field
            id="phoneNumber"
            fieldName="phoneNumber"
            label="common.phoneNumber"
            type="tel"
            placeholder="+389..."
          ></app-form-field>
          <div class="flex flex-col gap-4">
            <label for="languageCode">{{ 'common.language' | transloco }}</label>
            <p-select
              id="languageCode"
              [options]="languageOptions"
              formControlName="languageCode"
              placeholder="Select Language"
            ></p-select>
          </div>
        </div>
      </p-fluid>
    </div>
  </form>

  @if (showNewsletterSubscription) {
    <app-newsletter-subscription></app-newsletter-subscription>
  }

  @if (showCustomerAdminFields) {
    <form [formGroup]="form" (ngSubmit)="onSubmitBilling()" class="card mt-5">
      <div class="flex flex-col h-full">
        <div class="flex items-center">
          <div class="relative flex items-center">
            <div class="font-semibold text-xl">{{ t('billingInformation.header') }}</div>
          </div>
          <div class="flex items-center ml-auto">
            @if (editingBilling) {
              <p-button
                data-testid="save-billing-button"
                type="submit"
                label="{{ 'common.save' | transloco }}"
                [loading]="submittingBilling"
              ></p-button>
            } @else {
              <p-button
                data-testid="edit-billing-button"
                label="{{ 'common.edit' | transloco }}"
                (onClick)="onEditBilling()"
                severity="secondary"
              />
            }
          </div>
        </div>
        <p-fluid>
          <div class="flex flex-col gap-4 mt-4 mb-4">
            <app-billing-form [initiallyDisabled]="true"></app-billing-form>
          </div>
        </p-fluid>
      </div>
    </form>
  }
</div>
